import services from '../../services'

const state = {
    exhiList: [],
    isShowList: [],
    hotelLock: []
}

const mutations = {

    /**
     * 展会配置首页列表
     * @param {*} state
     * @param {*} payload
     */
    setExhiList(state, payload) {
        state.exhiList = payload
    },
    setIsShowList(state, payload) {
        state.isShowList = payload
    },
    setLockType(state, payload) {
        state.hotelLock = payload && payload.data && payload.data.data
    }
}

const actions = {

    /**
     * 展会配置首页列表
     */
    getExhiIndexList(context, param) {
        return new Promise((resolve, reject) => {
            services.exhiConfigSer.getExhiIndexList(param).then((res) => {
                context.commit('setExhiList', res && res.data && res.data.data || [])
                resolve(res)
            })
        })
    },

    /**
     * 展会推荐开关
     */
    changeExhiSwitch(context, param) {
        return new Promise((resolve, reject) => {
            services.exhiConfigSer.changeExhiSwitch(param).then((res) => {
                resolve(res)
            })
        })
    },

    /**
     * 展会是否可见
     */
    changeExhiVisible(context, param) {
        return new Promise((resolve, reject) => {
            services.exhiConfigSer.changeExhiVisible(param).then((res) => {
                resolve(res)
            })
        })
    },

    /**
     * 展会编辑页
     */
    editExhiInfo(context, param) {
        return new Promise((resolve, reject) => {
            services.exhiConfigSer.editExhiInfo(param).then((res) => {
                resolve(res)
            })
        })
    },

    /**
     * 保存  编辑的展会
     */
    editExhi(context, param) {
        return new Promise((resolve, reject) => {
            services.exhiConfigSer.editExhi(param).then((res) => {
                resolve(res)
            })
        })
    },

    /**
     * 保存  新增的展会
     */
    addExhi(context, param) {
        return new Promise((resolve, reject) => {
            services.exhiConfigSer.addExhi(param).then((res) => {
                resolve(res)
            })
        })
    },

    /**
     * 查看展会详情
     */
    getExhiDetail(context, param) {
        return new Promise((resolve, reject) => {
            services.exhiConfigSer.getExhiDetail(param).then((res) => {
                resolve(res)
            })
        })
    },

    /**
     * 弹出cims展会收索页
     * @param {*} context
     * @param {*} param
     */
    searchCimsExhiList(context, param) {
        return new Promise((resolve, reject) => {
            services.exhiConfigSer.searchCimsExhiList(param).then((res) => {
                resolve(res)
            })
        })
    },

    /**
     * 请求编辑展会信息
     * @param {*} context
     * @param {*} param
     */
    getEditExhiInfo(context, param) {
        return new Promise((resolve, reject) => {
            services.exhiConfigSer.getEditExhiInfo(param).then((res) => {
                resolve(res)
            })
        })
    },

    /**
     * 锁类型
     * @param {*} context
     * @param {*} param
     */
    lockType(context, param) {
        return new Promise((resolve, reject) => {
            services.exhiConfigSer.lockType(param).then((res) => {
                context.commit('setLockType', res || [])
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 展会是否可见 lookUp
     * @param {*} context
     * @param {*} param
     */
    getIsVisible(context, param = {}) {
        return new Promise((resolve, reject) => {
            services.exhiConfigSer.getIsVisible(param).then((res) => {
                context.commit('setIsShowList', res && res.data && res.data.data || [])
                resolve(res)
            })
        })
    },

    /**
     *  cims 展会详情
     * @param {*} context
     * @param {*} param
     */
    getCimsExhiDetail(context, param = {}) {
        return new Promise((resolve, reject) => {
            services.exhiConfigSer.getCimsExhiDetail(param).then((res) => {
                resolve(res)
            })
        })
    },

    /**
     *  展会配置列表导出
     * @param {*} context
     * @param {*} param
     */
    exportList(context, param = {}) {
        return new Promise((resolve, reject) => {
            services.exhiConfigSer.exportList(param).then((res) => {
                resolve(res)
            })
        })
    }
}

export default {
    state,
    namespaced: true,
    mutations,
    actions
}
